import Styled from 'styled-components';

export const Container = Styled.section`
  border-radius: 8px;
  padding: 24px 0;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Header = Styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SectionTitle = Styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: var(--primary-color);
  margin: 0;
`;

export const ProgramName = Styled.h4`
  font-size: 24px;
  font-weight: 700;
  color: var(--primary-color);
  margin: 8px 0 0;
  text-transform: uppercase;
`;

export const Details = Styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Row = Styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  column-gap: 16px;
  align-items: center;
`;

export const ColLabel = Styled.span`
  font-size: 14px;
  font-weight: 600;
  color: var(--primary-color);
  opacity: 0.8;
  text-transform: uppercase;
`;

export const ColValue = Styled.span`
  font-size: 14px;
  font-weight: 600;
  color: var(--primary-color);
`;

export const Divider = Styled.hr`
  border: none;
  border-top: 1px solid #D7D7DB;
  margin: 8px 0 4px;
`;


